import './styles.scss';

export default {
    name: 'LineThicknessDropdown',

    data() {
        return {
            current: '',
        };
    },

    methods: {
        chooseThickness(thickness) {
            this.current = thickness;
            this.$ionic.popoverController.dismiss(thickness);
        },
    }
};